<!-- 个人信息 -->
<template>
  <div class="el-userInfo">
    <el-row class="page_content">
      <h1 class="head_title">基本信息</h1>
      <el-descriptions :colon="false">
        <el-descriptions-item label="姓名：">{{userInfo.studentName}}</el-descriptions-item>
        <el-descriptions-item label="考生号：">{{userInfo.studentTestNo}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="学号：">{{userInfo.studentNo}} </el-descriptions-item>
        <el-descriptions-item label="身份证号：">{{userInfo.studentIdCard}} </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="学籍状态：">
          {{$studentState(userInfo.studentStatusState)}}</el-descriptions-item>
        <el-descriptions-item label="政治面貌：">{{userInfo.studentPoliticalOutlook}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="性别：">{{userInfo.studentSex == 1?"男":userInfo.studentSex == 2?"女":"保密"}}
        </el-descriptions-item>
        <el-descriptions-item label="邮政编码：">{{userInfo.postalCode}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="民族：">{{userInfo.studentNation}}</el-descriptions-item>
        <el-descriptions-item label="联系电话：">{{userInfo.studentPhone}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="出生年月：">{{$timeFormat(userInfo.studentBirthday, 'yyyy-MM-dd')}}</el-descriptions-item>
        <el-descriptions-item label="电子邮箱：">{{userInfo.studentEmail}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false" v-if="!this.$strExistHostnameOnce(['lfjtysxx'])">
        <el-descriptions-item label="报考学校：">{{userInfo.targetUniversityName}}</el-descriptions-item>
        <el-descriptions-item label="工作单位：">{{userInfo.studentJobAddress}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false" class="lxdz" v-if="!this.$strExistHostnameOnce(['lfjtysxx'])">
        <el-descriptions-item label="联系地址：">{{userInfo.studentAddress}}</el-descriptions-item>
        <el-descriptions-item label="QQ 群：" v-if="this.$strExistHostnameOnce(['xttc'])">{{QQGroup}}</el-descriptions-item>
      </el-descriptions>
      <template v-if="this.$strExistHostnameOnce(['hevttc','localhost'])">
        <el-descriptions :colon="false" v-if="expandData">
          <el-descriptions-item label="曾用名：">{{expandData['曾用名']}}</el-descriptions-item>
          <el-descriptions-item label="籍贯：">{{expandData['籍贯']}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" v-if="expandData" class="lxdz sss">
          <el-descriptions-item label="何时何地加入党、团组织：">{{expandData['何时何地加入党、团组织']}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" v-if="expandData">
          <el-descriptions-item label="介绍人姓名：">{{expandData['介绍人姓名']}}</el-descriptions-item>
          <el-descriptions-item label="有何特长：">{{expandData['有何特长']}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" v-if="expandData" class="lxdz sss">
          <el-descriptions-item label="何时何地受过何种奖励或者处分：">{{expandData['何时何地受过何种奖励或者处分']}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" v-if="expandData" class="lxdz">
          <el-descriptions-item label="奖惩记录：">{{expandData['奖惩记录']}}</el-descriptions-item>
        </el-descriptions>
      </template>

      <h1 class="head_title" style="margin-top:20px;">专业信息</h1>
      <el-descriptions :colon="false">
        <el-descriptions-item label="年级：">{{userInfo.grade}}</el-descriptions-item>
        <el-descriptions-item label="学习形式：">{{userInfo.learningModalityConcat}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="专业名称：">{{userInfo.professionalName}}</el-descriptions-item>
        <el-descriptions-item label="层次：">{{userInfo.cultivationLevelConcat}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false">
        <el-descriptions-item label="学制：">{{userInfo.professionalLength}}</el-descriptions-item>
        <el-descriptions-item label="函授站：">{{userInfo.corSchoolName}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :colon="false" class="lxdz">
        <el-descriptions-item label="入学日期：">{{userInfo.admissionDate}}</el-descriptions-item>
      </el-descriptions>
      <template v-if="this.$strExistHostnameOnce(['hevttc','localhost'])">
          <h1 class="head_title" style="margin-top:20px;">工作履历</h1>
          <el-table :data="workHistoryList" border style="width: 100%;">
            <el-table-column prop="自何年何月" label="自何年何月" align="center"  width="200">
                <template slot-scope="scope">{{scope.row['自何年何月']}}&nbsp;</template>
            </el-table-column>
            <el-table-column prop="至何年何月" label="至何年何月" align="center"  width="200"></el-table-column>
            <el-table-column prop="证明人" label="证明人" align="center"  width="200"></el-table-column>
            <el-table-column prop="在何地学习、工作及担任职务" label="在何地学习、工作及担任职务" align="center"></el-table-column>
          </el-table>
          <h1 class="head_title" style="margin-top:20px;">家庭成员</h1>
          <el-table :data="familyMemberList" border style="width: 100%">
            <el-table-column prop="姓名" label="姓名" align="center" width="200">
                <template slot-scope="scope">{{scope.row['姓名']}}&nbsp;</template>
            </el-table-column>
            <el-table-column prop="称呼" label="称呼" align="center"  width="200"></el-table-column>
            <el-table-column prop="政治面貌" label="政治面貌" align="center"  width="200"></el-table-column>
            <el-table-column prop="工作单位及职务" label="工作单位及职务" align="center"></el-table-column>
          </el-table>
      </template>
      <el-button round class="but" @click="editUserInfo">修 改</el-button>
    </el-row>


    <el-dialog title="" :visible.sync="show" width="1000px" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" label-position="right" :model="form" label-width="150px" style="max-height: 600px; overflow-y: auto;">
        <el-form-item label="政治面貌：">
            <el-select v-model="form.studentPoliticalOutlook">
                <el-option v-for="(item,index) in politicalOutlookList" :key="'politicalOutlookList'+index" :value="item" :label="item">{{item}}</el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="民族：">
            <el-select v-model="form.studentNation">
                <el-option v-for="(item,index) in nationDataList" :key="'nationDataList'+index" :value="item" :label="item">{{item}}</el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="邮政编号：">
          <el-input v-model="form.postalCode" autocomplete="off"></el-input>
        </el-form-item>
        <template v-if="!isPhoneValidator">
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.studentPhone" maxlength="11"></el-input>
            </el-form-item>
        </template>
        <el-form-item label="电子邮箱：" prop="email">
          <el-input v-model="form.studentEmail"></el-input>
        </el-form-item>
        <el-form-item label="联系地址：" prop="studentAddress">
          <el-input v-model="form.studentAddress"></el-input>
        </el-form-item>
        <el-form-item label="工作单位：">
          <el-input v-model="form.studentJobAddress"></el-input>
        </el-form-item>

        <template v-if="this.$strExistHostnameOnce(['hevttc','localhost'])">
          <el-divider>扩展信息</el-divider>

          <el-form-item label="曾用名：">
            <el-input v-model="form.formerName"></el-input>
          </el-form-item>
          <el-form-item label="籍贯：">
            <el-input v-model="form.nativePlace"></el-input>
          </el-form-item>
          <el-form-item label="何时何地加入党、团组织：" class="lineHeight20">
            <el-input v-model="form.partyOrganization" type="textarea" :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="介绍人姓名：">
            <el-input v-model="form.introducerName"></el-input>
          </el-form-item>
          <el-form-item label="何时何地受过何种奖励或者处分：" class="lineHeight20">
            <el-input v-model="form.rewardsOrPunishments" type="textarea" :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="有何特长：">
            <el-input v-model="form.specialty"></el-input>
          </el-form-item>
          <el-form-item label="奖惩记录：" class="lineHeight20">
            <el-input v-model="form.rewardsPunishmentsRecord" type="textarea" :rows="2"></el-input>
          </el-form-item>

          <el-divider>工作履历（最多8条）</el-divider>
          <div v-for="(item, index) in form.workHistoryList" :key="'work'+index" style="border: 1px solid #EBEEF5; padding: 10px; margin-bottom: 10px; border-radius: 4px;">
            <h4 style="margin-top: 0;">第{{index + 1}}条</h4>
            <el-form-item label="自何年何月：">
              <el-input v-model="item['自何年何月']" placeholder="例：2020年1月"></el-input>
            </el-form-item>
            <el-form-item label="至何年何月：">
              <el-input v-model="item['至何年何月']" placeholder="例：2022年12月"></el-input>
            </el-form-item>
            <el-form-item label="在何地学习、工作及担任职务：" class="lineHeight20">
              <el-input v-model="item['在何地学习、工作及担任职务']" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <el-form-item label="证明人：">
              <el-input v-model="item['证明人']"></el-input>
            </el-form-item>
          </div>

          <el-divider>家庭成员（最多3条）</el-divider>
          <div v-for="(item, index) in form.familyMemberList" :key="'family'+index" style="border: 1px solid #EBEEF5; padding: 10px; margin-bottom: 10px; border-radius: 4px;">
            <h4 style="margin-top: 0;">第{{index + 1}}条</h4>
            <el-form-item label="姓名：">
              <el-input v-model="item['姓名']"></el-input>
            </el-form-item>
            <el-form-item label="称呼：">
              <el-input v-model="item['称呼']" placeholder="例：父亲、母亲、配偶"></el-input>
            </el-form-item>
            <el-form-item label="政治面貌：">
              <el-select v-model="item['政治面貌']">
                  <el-option v-for="(po,idx) in politicalOutlookList" :key="'po'+index+idx" :value="po" :label="po">{{po}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工作单位及职务：" class="lineHeight20">
              <el-input v-model="item['工作单位及职务']" type="textarea" :rows="2"></el-input>
            </el-form-item>
          </div>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="submitInfo" :loading="submitBut">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    isvalidPhone
  } from '../../common/validate';
  import {getNationDataList,getPoliticalOutlook}  from '../../common/nation.js';
  var validPhone = (rule, value, callback) => {
    if (!value) {
      callback();
    } else if (!isvalidPhone(value)) {
      callback(new Error('请输入正确的11位手机号码'));
    } else {
      callback();
    }
  }
  export default {
    name: "UserInfo",
    data() {
      return {
        show: false,
        userInfo: {

        },
        form: {
          postalCode: "", //邮政编号
          studentEmail: "", //电子邮箱
          studentPhone: "", //联系电话
          studentJobAddress: "", //工作单位
          studentNation:"", //民族
          studentPoliticalOutlook:"", //政治面貌
          studentAddress:"", //联系地址
          // expandDataMap字段
          formerName: "", //曾用名
          nativePlace: "", //籍贯
          partyOrganization: "", //何时何地加入党、团组织
          introducerName: "", //介绍人姓名
          rewardsOrPunishments: "", //何时何地受过何种奖励或者处分
          specialty: "", //有何特长
          rewardsPunishmentsRecord: "", //奖惩记录
          workHistoryList: [], //工作履历
          familyMemberList: [], //家庭成员
          type: []
        },
        submitBut: false,
        rules: {
          studentEmail: [{
              required: true,
              message: '请输入邮箱地址',
              trigger: 'blur'
            },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change']
            }
          ],

          // studentPhone: [{
          //     trigger: 'blur',
          //     validator: validPhone
          //   } //这里需要用到全局变量
          // ]
        },
        isPhoneValidator: true, //是否开启手机验证
        QQGroup:null,
        nationDataList:getNationDataList(),
        politicalOutlookList:getPoliticalOutlook(),
        expandData: null, // 扩展数据
        workHistoryList: [], // 工作履历列表（最多8条）
        familyMemberList: [], // 家庭成员列表（最多3条）
      };
    },
    created() {
      this.getPersonalInfo();
      this.getStuNewVerifyPhoneOpenConfig();

    },
    methods: {
        getStudentQQGroupInfo(corSchoolId){ //根据correspondenceSchoolId获取QQ群信息
            this.$store.dispatch("user/getStudentQQGroupInfo",{correspondenceSchoolId:corSchoolId}).then((ret) => {
                if(ret.code == 0){
                    this.QQGroup = ret.data;
                }
            })
        },
        getStuNewVerifyPhoneOpenConfig(){ //是否开启短信验证 开启了手机校验，不让在个人信息更改，关了可以改
            this.$store.dispatch("user/getStuNewVerifyPhoneOpenConfig").then((ret) => {
                if(ret.code == 0){
                    this.isPhoneValidator = ret.data.stuNewVerifyPhoneOpenConfig; // true开启 false为关闭
                }
            })
        },
        editUserInfo() {
            this.form.postalCode = this.userInfo.postalCode;
            this.form.studentEmail = this.userInfo.studentEmail;
            this.form.studentPhone = this.userInfo.studentPhone;
            this.form.studentJobAddress = this.userInfo.studentJobAddress;
            this.form.studentPoliticalOutlook = this.userInfo.studentPoliticalOutlook;
            this.form.studentNation = this.userInfo.studentNation;
            this.form.studentAddress = this.userInfo.studentAddress;

            // 填充expandDataMap数据（仅hevttc）
            if (this.$strExistHostnameOnce(['hevttc','localhost'])) {
                if (this.expandData) {
                    this.form.formerName = this.expandData['曾用名'] || '';
                    this.form.nativePlace = this.expandData['籍贯'] || '';
                    this.form.partyOrganization = this.expandData['何时何地加入党、团组织'] || '';
                    this.form.introducerName = this.expandData['介绍人姓名'] || '';
                    this.form.rewardsOrPunishments = this.expandData['何时何地受过何种奖励或者处分'] || '';
                    this.form.specialty = this.expandData['有何特长'] || '';
                    this.form.rewardsPunishmentsRecord = this.expandData['奖惩记录'] || '';
                } else {
                    this.form.formerName = '';
                    this.form.nativePlace = '';
                    this.form.partyOrganization = '';
                    this.form.introducerName = '';
                    this.form.rewardsOrPunishments = '';
                    this.form.specialty = '';
                    this.form.rewardsPunishmentsRecord = '';
                }

                // 深拷贝工作履历和家庭成员数据
                this.form.workHistoryList = JSON.parse(JSON.stringify(this.workHistoryList));
                this.form.familyMemberList = JSON.parse(JSON.stringify(this.familyMemberList));
            }

            this.show = true;
        },
      getPersonalInfo() {
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getPersonalInfo").then((ret) => {
                this.loading.close();
            if (ret.code === 0 || ret.code === '0') {
                this.userInfo = ret.data;

                // 处理扩展数据
                if (ret.data.expandDataMap) {
                    this.expandData = ret.data.expandDataMap;
                    // 处理工作履历（固定显示8条）
                    if (this.expandData['工作履历'] && Array.isArray(this.expandData['工作履历'])) {
                        this.workHistoryList = this.expandData['工作履历'].slice(0, 8);
                    } else {
                        this.workHistoryList = [];
                    }
                    // 补齐工作履历到8条
                    while (this.workHistoryList.length < 8) {
                        this.workHistoryList.push({
                            "自何年何月": "",
                            "至何年何月": "",
                            "在何地学习、工作及担任职务": "",
                            "证明人": ""
                        });
                    }

                    // 处理家庭成员（固定显示3条）
                    if (this.expandData['家庭成员'] && Array.isArray(this.expandData['家庭成员'])) {
                        this.familyMemberList = this.expandData['家庭成员'].slice(0, 3);
                    } else {
                        this.familyMemberList = [];
                    }
                    // 补齐家庭成员到3条
                    while (this.familyMemberList.length < 3) {
                        this.familyMemberList.push({
                            "姓名": "",
                            "称呼": "",
                            "政治面貌": "",
                            "工作单位及职务": ""
                        });
                    }
                } else {
                    // 如果没有expandDataMap，也初始化空数据
                    this.workHistoryList = [];
                    for (let i = 0; i < 8; i++) {
                        this.workHistoryList.push({
                            "自何年何月": "",
                            "至何年何月": "",
                            "在何地学习、工作及担任职务": "",
                            "证明人": ""
                        });
                    }
                    this.familyMemberList = [];
                    for (let i = 0; i < 3; i++) {
                        this.familyMemberList.push({
                            "姓名": "",
                            "称呼": "",
                            "政治面貌": "",
                            "工作单位及职务": ""
                        });
                    }
                }

                if(this.$strExistHostnameOnce(['xttc'])){ //邢台才显示QQ群信息
                      this.getStudentQQGroupInfo(ret.data.corSchoolId);
                }
            } else {
                this.$message({message: ret.msg,type: 'warning'});
            }
            }).catch(() => {
                this.loading.close();
            });
      },
      submitInfo() {
        if(this.isPhoneValidator){
            delete this.form.studentPhone;
        }else{
            if(!isvalidPhone(this.form.studentPhone)){
                this.$message({
                  showClose: true,
                  message: "请输入正确的电话号码！",
                  type: 'warning'
                });
                return;
            }
        }

        // 提交数据
        const submitData = {
            postalCode: this.form.postalCode,
            studentEmail: this.form.studentEmail,
            studentJobAddress: this.form.studentJobAddress,
            studentNation: this.form.studentNation,
            studentPoliticalOutlook: this.form.studentPoliticalOutlook,
            studentAddress: this.form.studentAddress
        };

        // 仅hevttc需要提交expandDataMapJson
        if (this.$strExistHostnameOnce(['hevttc','localhost'])) {
            // 过滤工作履历的空数据，只保留有效数据
            const validWorkHistory = this.form.workHistoryList.filter(item => {
                return item['自何年何月'] || item['至何年何月'] ||
                       item['在何地学习、工作及担任职务'] || item['证明人'];
            });

            // 过滤家庭成员的空数据，只保留有效数据
            const validFamilyMembers = this.form.familyMemberList.filter(item => {
                return item['姓名'] || item['称呼'] ||
                       item['政治面貌'] || item['工作单位及职务'];
            });

            // 构建expandDataMapJson
            const expandDataMap = {
                "曾用名": this.form.formerName,
                "籍贯": this.form.nativePlace,
                "何时何地加入党、团组织": this.form.partyOrganization,
                "介绍人姓名": this.form.introducerName,
                "何时何地受过何种奖励或者处分": this.form.rewardsOrPunishments,
                "有何特长": this.form.specialty,
                "工作履历": validWorkHistory,
                "家庭成员": validFamilyMembers,
                "奖惩记录": this.form.rewardsPunishmentsRecord
            };

            submitData.expandDataMapJson = JSON.stringify(expandDataMap);
        }

        if (!this.isPhoneValidator) {
            submitData.studentPhone = this.form.studentPhone;
        }

        this.submitBut = true;
        this.$store.dispatch("user/editPersonalInfo", submitData)
        .then((ret) => {
          this.submitBut = false;
          this.$message({
            showClose: true,
            message: ret.msg,
            type: ret.code == 0?'success':'warning'
          });
          if(ret.code == 0){
            this.show = false;
            this.getPersonalInfo();
          }
        }).catch(() => {
          this.submitBut = false;
        });
      }
    }
  };
</script>
<style lang="less">
  @import '../../styles/base.less';

  .el-userInfo {
    .page_content {
      padding: 0 20px 20px;
    }

    .el-descriptions-item__label {
      white-space: nowrap;
      width: 80px;
      text-align: right;
      padding-top: 10px;
    }

    .el-descriptions-item__container {
      font-size: 15px;
    }

    .el-descriptions-item__content {
      width: 40%;
      border-bottom: 1px solid #b0b0b0;
      padding: 10px 0 5px 10px;
      font-weight: 600;
    }

    .el-descriptions {
      padding-left: 35px;
    }

    .lxdz {
      .el-descriptions-item__content {
        width: 60%;
      }
    }

    .but {
      background-color: rgb(0, 191, 191);
      color: white;
      font-size: 15px;
      padding: 12px 30px;
      position: fixed;
      right: 50px;
      bottom: 50px;
    }

    .el-form-item{
        margin-bottom:10px;
    }
    .lineHeight20 .el-form-item__label{
        line-height: 25px;
    }
    .sss .el-descriptions-item__label {
        width: 200px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/UserInfo.vue